import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = ["src", "onClick"]

import { goToShare, MediaItem } from '@/view/home/supportScript';
import { ref, onMounted } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'mediaSection',
  props: {
    itemData: {}
  },
  setup(__props: any) {

const props = __props
const mediaList = ref(props.itemData.shareMediaList)

onMounted(() => {
    mediaList.value = props.itemData.shareMediaList
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mediaList.value, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        style: {"margin":"10px"}
      }, [
        (item.display)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: item.url,
              alt: "",
              onClick: ($event: any) => (_unref(goToShare)(item.redirectUrl))
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}
}

})